import React from 'react';
import { useRecordContext } from 'react-admin';
import { TSupplierFeature, TSupplier } from '@/api';
import { SupplierFeaturesTree } from './SupplierFeaturesTree';
import { SUPPLIER_FEATURES } from '@/constants/supplier-features';
import { getAllFeaturesAsEnabled } from '@/utils/supplier-features';

export const SupplierFeaturesField: React.FC = () => {
  const record = useRecordContext<TSupplier>();
  
  if (!record) {
    return null;
  }

  // If features is undefined, show all features as enabled (current behavior)
  // Otherwise, show the specific features that are configured
  const supplierFeatures = record.features === undefined 
    ? getAllFeaturesAsEnabled(SUPPLIER_FEATURES)
    : record.features;

  return (
    <SupplierFeaturesTree
      features={SUPPLIER_FEATURES}
      value={supplierFeatures}
      readOnly={true}
      title="Características Habilitadas"
    />
  );
};